import { Routes, Route } from 'react-router-dom';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { MaintenancePage } from '@/pages/Maintenance';
import HomeLayout from './layouts/HomeLayout';
import {
  HomePage,
  CasinoGames,
  GamePage,
  GameDetailsPage,
  BetProfitLossPage,
  BetHistoryPage,
  CasinoBetHistoryPage,
  UnsettledBetPage,
  StakeSettingsPage,
  RulesPage,
  ChangePasswordPage,
  AccountStatementPage,
  CommissionPage,
  BonusStatementPage,
  ExportReportHistoryPage,
  ResultsPage,
  InplayPage,
  RacingPage,
  RacingInside,
  WithdrawPage,
  DepositPage,
  ReferralPage,
  CoinsPage,
} from '@/routes';
import ModalManager from './components/ModalManager';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { FeatureRoute } from './components/common/FeatureRoute';
import ScrollToTop from './components/common/ScrollToTop';
import { PushNotificationPrompt } from './components/PushNotificationPrompt';
import { useBfcacheAuthGuard, useReferralRegisterModal, useFcmNotifications } from '@/hooks';
const sportsRoutes = ['Cricket', 'Football', 'Tennis'];

const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

export function App() {
  useBfcacheAuthGuard();
  useReferralRegisterModal();
  useFcmNotifications();

  if (isMaintenanceMode) {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }
  //
  return (
    <>
      <ScrollToTop />
      <PushNotificationPrompt />
      <Routes>
        {/* Protected Routes */}
        <Route element={<HomeLayout />}>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/" element={<HomePageLogin />} /> */}
          <Route path="/LIVECASINO" element={<CasinoGames pageType="LIVECASINO" />} />
          <Route path="/INDIANPOKER" element={<CasinoGames pageType="INDIANPOKER" />} />
          <Route path="/AURACASINO" element={<CasinoGames pageType="AURACASINO" />} />
          <Route path="/FANTASY11" element={<CasinoGames pageType="FANTASY11" />} />
          <Route path="/AVIATOR" element={<CasinoGames pageType="AVIATOR" />} />
          <Route path="/CHICKENROAD" element={<CasinoGames pageType="CHICKENROAD" />} />
          <Route path="/INTCASINO" element={<CasinoGames pageType="INTCASINO" />} />
          <Route path="/SLOT" element={<CasinoGames pageType="SLOT" />} />
          <Route path="/inplay" element={<InplayPage />} />
          {sportsRoutes.map((sport) => {
            const sportPath = sport.toLowerCase();
            return (
              <Route key={sport}>
                <Route path={`/sports/${sportPath}`} element={<InplayPage sportName={sport} />} />
                <Route
                  path={`/sports/${sportPath}/:competitionId`}
                  element={<InplayPage sportName={sport} />}
                />
                <Route
                  path={`/sports/${sportPath}/market-details/:eventId`}
                  element={<GameDetailsPage sportName={sport} />}
                />
              </Route>
            );
          })}
          <Route path="/racing/:sportName" element={<RacingPage />} />
          <Route path="/racing/:sportName/:competitionId" element={<RacingPage />} />
          <Route path="/details/:game/:eventId/:gameId" element={<RacingInside />} />
          <Route path="/details/:game/:eventId" element={<RacingInside />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/account-statement" element={<AccountStatementPage />} />
            <Route path="/commission" element={<CommissionPage />} />
            <Route path="/bonus-statement" element={<BonusStatementPage />} />
            <Route path="/export-report-history" element={<ExportReportHistoryPage />} />
            <Route path="/bet-history" element={<BetHistoryPage />} />
            <Route path="/casino-bet-history" element={<CasinoBetHistoryPage />} />
            <Route path="/unsettled-bet" element={<UnsettledBetPage />} />
            <Route path="/profit-loss" element={<BetProfitLossPage />} />
            <Route path="/stake-settings" element={<StakeSettingsPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/coins" element={<CoinsPage />} />
            <Route path="/GAME/:id" element={<GamePage />} />
            <Route
              path="/deposit"
              element={
                <FeatureRoute feature="deposit">
                  <DepositPage />
                </FeatureRoute>
              }
            />
            <Route
              path="/withdraw"
              element={
                <FeatureRoute feature="withdrawal">
                  <WithdrawPage />
                </FeatureRoute>
              }
            />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Global modal renderer — controlled via Redux dispatch(openModal('login')) */}
      <ModalManager />
    </>
  );
}
